export default {
  TableHeadGameReport: [
    [
      {
        displayName: 'report.gameReport.datatable.number',
      },
      {
        displayName: 'report.gameReport.datatable.amb',
      },
      {
        displayName: 'report.gameReport.datatable.player',
      },
      {
        displayName: 'report.gameReport.datatable.newPlayer',
      },
      {
        displayName: 'report.gameReport.datatable.turnover',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'report.gameReport.datatable.count',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'report.gameReport.datatable.rtp',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'report.gameReport.datatable.netwin',
        attr: {
          class: 'text-right',
        },
      },
      // {
      //   displayName: 'report.gameReport.datatable.wl',
      //   attr: {
      //     class: 'text-right',
      //   },
      // },
      {
        displayName: 'report.gameReport.datatable.wlamb',
        attr: {
          class: 'text-right',
        },
      },
    ],
  ],
};
